<template>
  <div class="cod-pagination">
    <!-- Left: first / previous -->
    <div class="left-group">
      <button
        class="pill-btn"
        :disabled="isFirstPage"
        @click="changePage(1)"
      >
        ກັບໜ້າທຳອິດ
      </button>
      <button
        class="pill-btn"
        :disabled="isFirstPage"
        @click="changePage(pagination.current_page - 1)"
      >
        ກ່ອນໜ້າ
      </button>
    </div>

    <!-- Center: numbered circles -->
    <div class="number-group">
      <button
        v-for="p in pages"
        :key="p"
        class="page-circle"
        :class="{ active: p === pagination.current_page }"
        @click="changePage(p)"
      >
        {{ p }}
      </button>
    </div>

    <!-- Right: next / last -->
    <div class="right-group">
      <button
        class="pill-btn outline"
        :disabled="isLastPage"
        @click="changePage(pagination.current_page + 1)"
      >
        ຖັດໄປ
      </button>
      <button
        class="pill-btn outline"
        :disabled="isLastPage"
        @click="changePage(pagination.last_page)"
      >
        ໄປໜ້າສຸດທ້າຍ
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CodPagination',
  props: {
    pagination: { type: Object, required: true },
    offset: { type: Number, default: 10 },
  },
  computed: {
    isFirstPage() {
      return this.pagination.current_page <= 1;
    },
    isLastPage() {
      return this.pagination.current_page >= this.pagination.last_page;
    },
    pages() {
      const pages = [];
      let from = this.pagination.current_page - Math.floor(this.offset / 2);
      if (from < 1) from = 1;
      let to = from + this.offset - 1;
      if (to > this.pagination.last_page) to = this.pagination.last_page;
      while (from <= to) {
        pages.push(from);
        from++;
      }
      return pages;
    },
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.pagination.last_page) return;
      if (page === this.pagination.current_page) return;
      this.pagination.current_page = page;
      this.$emit('paginate', page);
    },
  },
};
</script>

<style lang="scss" scoped>
.cod-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 8px;
  flex-wrap: wrap;
}

.left-group,
.right-group {
  display: flex;
  gap: 8px;
}

.number-group {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  flex: 1;
}

// Pill buttons (left + right)
.pill-btn {
  height: 36px;
  padding: 0 14px;
  border-radius: 18px;
  font-size: 13px;
  font-family: $font;
  border: 1px solid transparent;
  background: #f0f1f5;
  color: #8b8f99;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: #e6e9ef;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  &.outline {
    background: #fff;
    border-color: #d9dde3;
    color: #4b5161;

    &:hover:not(:disabled) {
      border-color: #195BFF;
      color: #195BFF;
    }
  }
}

// Numbered circles
.page-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #d9dde3;
  background: #fff;
  color: #4b5161;
  font-size: 13px;
  font-family: $font;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s, border-color 0.15s;

  &:hover {
    border-color: #195BFF;
    color: #195BFF;
  }

  &.active {
    background: #195BFF;
    color: #fff;
    border-color: #195BFF;
    font-weight: 600;
  }
}

@media (max-width: 768px) {
  .cod-pagination {
    justify-content: center;
  }
  .number-group {
    order: -1;
    width: 100%;
  }
}
</style>
